<template>
  <div class="ml-6 mr-6" :style="navbarWithName ? 'margin-left: 165px !important; margin-right: auto !important;' : ''"><!--note: mt,mb,ml,mr(margin) jangan diubah-->
  <v-breadcrumbs :items="page" class="pa-0 ma-0 my-6 mt-0 pt-0"></v-breadcrumbs>
  <v-alert class="mb-3" v-if="alert" border="top" :color="colorAlert" dark>
    {{ message }}
  </v-alert>

  <!--TOPIC DAN PERIODE BERITA-->
    <v-btn
      class="color-avatar3"
      v-scroll="onScroll"
      v-show="fab"
      fab
      dark
      fixed
      bottom
      right
      color="primary"
      @click="toBottom"
    >
      <v-icon>mdi-chevron-down</v-icon>
    </v-btn>

    <v-layout row wrap class="my-4">
      <!-- <v-col class="d-flex ma-0 pa-0" cols="12" sm="2">
        <v-select
          :items="topicsentiment"
          item-text="name1"
          item-value="name2"
          v-model="selectedTopic"
          class="elevation-0 shadow-0"
          label="Topic"
          dense
          outlined
          rounded
          @change="loadKontenBerita"
        ></v-select>
      </v-col> -->
      <v-col class="d-flex ma-0 pa-0 mx-3" cols="12" sm="2">
        <v-select
          :items="periodeberita"
          v-model="selectedPeriode"
          class="elevation-0"
          label="Periode Berita"
          background-color="#0471A5"
          dark
          dense
          solo
          rounded
          @change="loadKontenBerita"
        >
          <template v-slot:append-item>
            <v-list-item>
              <v-list-item-title>
                <v-menu
                  v-model="menu"
                  :close-on-content-click="false"
                  :nudge-width="200"
                  offset-x
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      small
                      dark
                      width="120"
                      color="#0471A5"
                      @click="selectedPeriode = 'Custom Date'"
                    >
                      Custom
                    </v-btn>
                  </template>
                  <v-card>
                    <v-row justify="space-around" class="ma-4">
                      <v-date-picker
                        v-model="date1"
                        dense
                        :show-current="false"
                        color="#0471A5"
                        @change="showCustomDate"
                      ></v-date-picker>
                      <v-date-picker
                        v-model="date2"
                        class="ml-8"
                        :show-current="false"
                        color="#0471A5"
                        header-color="#0471A5"
                        @change="showCustomDate"
                      ></v-date-picker>
                    </v-row>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn text @click="menu = false">
                        Cancel
                      </v-btn>
                      <v-btn color="primary" text @click="menu = false, loadKontenBerita()">
                        Set
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-menu>
              </v-list-item-title>
            </v-list-item>
          </template>
        </v-select>
      </v-col>
      <v-col class="d-flex ma-0 pa-0 mx-3" cols="12" sm="3">
        <v-card v-if="(showDate1 != '' && showDate2 != '') || selectedPeriode == 'Custom'" height="37" outlined style="border-radius: 30px;">
          <v-card-text class="pa-2 px-4">
            <v-icon>mdi-calendar</v-icon>
            <span class="mt-2 ml-1">
              {{ showDate1[1] + " " + showDate1[0] + " " + showDate1[2] }} - {{ showDate2[1] + " " + showDate2[0] + " " + showDate2[2] }}
            </span>
          </v-card-text>
        </v-card>
      </v-col>
    </v-layout>
    <!--END TOPIC DAN PERIODE BERITA-->
    <v-row wrap class="mb-4"  >
      <v-flex lg="6" sm="12" class="chart-container">
          <v-card-title >JVM Non Heap</v-card-title>
          <div >            
            <apexcharts  class="mr-3" type="area" :options="chartOptionsSolr" :series="chartSeriesJvm" ></apexcharts>
          </div>
      </v-flex>
    </v-row>
      <v-dialog v-model="dialogLoading" persistent max-width="290">
        <v-card>
          <v-card-title class="text-h6 font-weight-medium align-center justify-center">
            Page loading
          </v-card-title>
          <v-card-text class="body-1 align-center justify-center">
            Loading content, please wait
          </v-card-text>
          <v-card-title class="align-center justify-center">
            <v-progress-circular
              :size="70"
              :width="7"
              color="#0471A5"
              indeterminate
            ></v-progress-circular>
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#0471A5" text @click="dialogLoading = false">
              cancel
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    <!-- </v-layout> -->
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import axios from "axios";
import { mapGetters } from 'vuex';

export default {
  components: {
    apexcharts: VueApexCharts,
  },
  data() {
    return {
      setTanggal: [],
      driftScoreGrafik: [],
      oovGrafik: [],
      nonLetterGrafik: [],
      textLengthGrafik: [],
      tableDataCharacteristic: [],
      // selectedTopic: "bnpt",
      selectedPeriode: "Today",
      dateStart: "",
      dateEnd: "",
      periodeberita: [
        "Today",
        "Yesterday",
        "Last 7 Days",
        "Previous Week",
        "Last 30 Days",
        "Previous Month",
      ],
      date1: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      date2: new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      showDate1 : "",
      showDate2: "",
      dialogLoading: false,
      dialoginfo: false,
      menu: false,
      alert: false,
      colorAlert: "",
      message : "",
      chartOptionsSolr: {
        chart: {
          id: 'solr-memory-line-chart',
          type: 'area', 
          animations: {
            enabled: true,
            dynamicAnimation: {
              speed: 1000
            }
          },
          zoom: {
            enabled: false
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'smooth',
          colors: ['#00E396', '#FF4560'], // Set different colors for heap and non-heap
        },
        xaxis: {
          type: 'datetime', // For time series data
        },
        yaxis: {
          title: {
            text: 'Memory (GB)',
          },
        },
        tooltip: {
          x: {
            format: 'dd MMM yyyy HH:mm:ss', // Format for datetime tooltip
          },
          y: {
            formatter: function (val) {
              return `${val} GB`;
            }
          }
        },
        legend: {
          position: 'top',
        },
      },

      chartSeriesJvm: [{
        name: 'JVM Non Heap',
        data: [],
      }],
    };
  },
  computed: {
    ...mapGetters(['navbarWithName']), // Accessing navbarWithName from Vuex
  },
  mounted() {
    this.loadKontenBerita();
  },
  methods: {
    showCustomDate() {
      var date = new Date(this.date1);
      var day2 = (date.getMonth() > 8 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1)) + "/" +
        (date.getDate() > 9 ? date.getDate() : "0" + date.getDate()) + "/" +
        date.getFullYear();

      const parts = day2.split("/");
      parts.unshift(parts.pop());
      parts[1] -= 1;
      var dateString = new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
        timeZone: "UTC"
      }).format(Date.UTC(...parts)).replace(/,/g, "");

      dateString = dateString.split(" ");
      this.showDate1 = dateString;

      var date3 = new Date(this.date2);
      var day4 = (date3.getMonth() > 8 ? date3.getMonth() + 1 : "0" + (date3.getMonth() + 1)) + "/" +
        (date3.getDate() > 9 ? date3.getDate() : "0" + date3.getDate()) + "/" +
        date3.getFullYear();

      const parts2 = day4.split("/");
      parts2.unshift(parts2.pop());
      parts2[1] -= 1;
      var dateString2 = new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
        timeZone: "UTC"
      }).format(Date.UTC(...parts2)).replace(/,/g, "");

      dateString2 = dateString2.split(" ");
      this.showDate2 = dateString2;
    },
    
    async loadKontenBerita() {
      this.dialogLoading = true;
      try {
        const date_awal = new Date();
        const date = new Date();
        date.setDate(date.getDate() + 0);
        const datenow = date.toISOString().substr(0, 10);

        // Setting date ranges based on selected period
        if (this.selectedPeriode == "Today") {
          this.dateStart = datenow;
          this.dateEnd = datenow;
        }
        if (this.selectedPeriode == "Yesterday") {
          date_awal.setDate(date_awal.getDate() - 1);
          this.dateStart = date_awal.toISOString().substr(0, 10);
          this.dateEnd = this.dateStart;
        }
        if (this.selectedPeriode == "Last 7 Days" || this.selectedPeriode == "Previous Week") {
          date_awal.setDate(date_awal.getDate() - 7);
          this.dateStart = date_awal.toISOString().substr(0, 10);
          this.dateEnd = datenow;
        }
        if (this.selectedPeriode == "Last 30 Days" || this.selectedPeriode == "Previous Month") {
          date_awal.setDate(date_awal.getDate() - 30);
          this.dateStart = date_awal.toISOString().substr(0, 10);
          this.dateEnd = datenow;
        }
        if (this.selectedPeriode == "Custom Date") {
          this.dateStart = this.date1;
          this.dateEnd = this.date2;
        }

        // Convert to Unix timestamps with fractional seconds
        const datest = new Date(this.dateStart + 'T00:00:00Z');
        const unixTimestamp = datest.getTime() / 1000;
        const startdate = unixTimestamp + 0.24;

        const date_end = new Date(this.dateEnd + 'T23:59:59Z');
        const unixTimestamp_end = date_end.getTime() / 1000;
        const enddate = unixTimestamp_end + 0.24;

        
        // Fetch data from Prometheus
        const prometheusUrlRange = 'http://172.20.4.13:9090/api/v1/query_range';
        const jvm_non_heap = await axios.get(prometheusUrlRange, {
          params: { 
            query: 'solr_metrics_jvm_memory_non_heap_bytes',
            start: startdate,
            end: enddate,
            step: 14
          },
        });

        // Process the data
        const data_jvm_non_heap = jvm_non_heap.data.data.result[0].values;

        const chartDataJvmNonHeap = data_jvm_non_heap.map(item => {
          const timestamp = new Date(item[0] * 1000);  // Convert Unix timestamp to Date
          const memoryInGB = item[1] / (1024 * 1024 * 1024);  // Convert bytes to GB
          return [timestamp.getTime(), parseFloat(memoryInGB).toFixed(2)];  // Prepare data for ApexCharts
        });

        // Add to chart data
        this.chartSeriesJvm[0].data = chartDataJvmNonHeap;

        this.dialogLoading = false;


        this.dialogLoading = false;

      } catch (e) {
        console.log(e);
        this.alert = true;
        this.message = "Data Not Found";
        this.colorAlert = "red";
        this.dialogLoading = false;
        setTimeout(() => {
          this.alert = false;
        }, 3000);
      }
    }

  }
};
</script>

<style> /*note css jangan diubah*/

.btn-ok{
  background-image: linear-gradient(to bottom, #ff8b8b, #ff8284, #ff787d, #ff6e76, #ff646f, #ff5c6a, #ff5464, #ff4b5f, #ff4359, #ff3b54, #ff314e, #ff2648);
}
.v-avatar.color-avatar3
{
  box-shadow: 0 5px 15px rgba(255, 0, 0, 0.4);
  background-image: linear-gradient(to bottom, #ff8b8b, #ff8284, #ff787d, #ff6e76, #ff646f, #ff5c6a, #ff5464, #ff4b5f, #ff4359, #ff3b54, #ff314e, #ff2648);
}
.chart-container {
  
  box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.1);
  /* padding: 10px; */
  border-radius: 8px; /* Rounded corners */
  margin-bottom: 10px; /* Margin below each chart */
  margin-left: 10px;   /* Margin on the left of each chart */
  margin-right: 10px;  /* Margin on the right of each chart */
}

/* Targeting specific classes */
.apexcharts-canvas {
  width: 100% !important; 
  margin-left: 5px;
  margin-right: 5px;
  height: 250px !important;
}
.apexcharts-svg {
  margin: 0;
}
.apexchartsavailable-memory-line-chart {
  /* Adjust width, margin or padding if needed */
  width: 100% !important; 
  height: 240px !important; /* Adjust height if necessary */
}
.apexcharts-theme-light .apexcharts-xaxis-texts tspan {
  /* Example of changing text color of X-axis labels */
  fill: #226077;
}

.v-sheet--offset {
  top: -24px;
  position: relative;
}
div.apexcharts-canvas.apexcharts-theme-dark {
  background: transparent !important;
}

.tooltip .tooltip-inner {
  max-width: 100px !important;
  width: 100px !important;
}
.v-tooltip__content {
  font-size: 12px !important;
  max-width: 150px;
}
.row-pointer {
  cursor: pointer;
}

.v-avatar.color-avatar {
  background-image:
  linear-gradient(to right top, #5a6fe8, #6174ea, #6879ed, #6f7fef, #7584f1, #7d8af3, #8590f5, #8d96f7, #989ff9, #a2a7fb, #acb0fd, #b6b9ff);
}
.v-avatar.color-avatar2 {
  background-image:
  linear-gradient(to right top, #ec6497, #ef6d94, #f27693, #f47f92, #f58892, #f78f91, #f99791, #fa9e91, #fca690, #fdae8f, #feb690, #febe91);
}
.buttonstyle {
  box-shadow: 0 5px 15px rgba(153, 0, 255, 0.4);
  background-image:
  linear-gradient(to right top, #5a6fe8, #6174ea, #6879ed, #6f7fef, #7584f1, #7d8af3, #8590f5, #8d96f7, #989ff9, #a2a7fb, #acb0fd, #b6b9ff);
}
.v-avatar.color-avatar5 {
  background-image:
  linear-gradient(to right top, #dc922b, rgb(198, 128, 14), #fec864, #ffcc5e, #ffd057, #ffd359, #ffd65a, #ffd95c, #ffdb66, #ffde6f, #ffe079, #ffe282);
}
</style>